import Login from '../interfaces/Login';

export const INITIAL_VALUES: Login = {
    user: "",
    pass: ""
}